import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "slug": "/"
};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const Text = makeShortcode("Text");
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <Text sx={{
      fontSize: [4, 5, 6],
      fontWeight: `bold`,
      color: `heading`
    }} mdxType="Text">
  👋🏼 Hey, I'm Vikyath.
    </Text>
    <p>{`I work on backend systems, distributed systems, performance tuning, and trying to keep microservices from falling apart on random Tuesdays.`}</p>
    <p>{`I've spent time wrangling backend systems across compliance, cloud, and product-heavy platforms. I like systems with real constraints, weird edge cases, and enough moving parts to stay interesting.`}</p>
    <p>{`Currently at Twilio, pushing backend systems and APIs to behave themselves under real load and whatever us-east-1 feels like that day.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      